const GET_BULK_ORDER_SAVE = "GET_BULK_ORDER_SAVE"
const SET_BULK_ORDER_SAVE = "SET_BULK_ORDER_SAVE"

export{
    GET_BULK_ORDER_SAVE,
    SET_BULK_ORDER_SAVE
}